import { render, staticRenderFns } from "./MiddleCom.vue?vue&type=template&id=2c8201f7&scoped=true"
import script from "./MiddleCom.vue?vue&type=script&lang=js"
export * from "./MiddleCom.vue?vue&type=script&lang=js"
import style0 from "./MiddleCom.vue?vue&type=style&index=0&id=2c8201f7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c8201f7",
  null
  
)

export default component.exports